import * as Typings from '../typings'
import {
  BRAND_LIST,
  Countries,
  CountryLanguageSwitcher,
  Languages,
} from '../../typings'

const CanadaLocale: Typings.LocaleType = {
  REGION: Typings.RegionGroupNames.NORTH_AMERICA,
  CODE: 'ca',

  LONG_NAME: 'Canada',
  SHORT_NAME: 'CA',

  DISPLAY_COUNTRY: 'Canada',

  LANGUAGES: {
    EN: 'en',
    FR: 'fr',
  },

  CMS_ENABLED: {
    [BRAND_LIST.UQ]: true,
  },

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 58.695433501291085,
    INITIAL_LONGITUDE: -96,
    INITIAL_ZOOM: 3,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  [BRAND_LIST.UQ]: {
    [Languages.EN]: {
      LANGUAGE_CODE: 'en',
      DISPLAY_NAME: 'Canada (English)',
      TERMS_OF_USE_URL:
        'https://faq-ca.uniqlo.com/pkb_Home?id=kA31I000000I8kF&l=en_US&c=category_uq%3AUQ_C1_1&fs=Search&pn=1',
      PRIVACY_POLICY_URL:
        'https://faq-ca.uniqlo.com/pkb_Home?id=kA31I000000I8kK&l=en_US&fs=Search&pn=1',
      HOME_PAGE_URL: 'https://uniqlo.com/ca/en/',
      CONTACT_US_URL: 'https://faq-ca.uniqlo.com/pkb_Home?l=en_US',
    },
    [Languages.FR]: {
      LANGUAGE_CODE: 'fr',
      DISPLAY_NAME: 'Canada (Français)',
      TERMS_OF_USE_URL:
        'https://faq-ca.uniqlo.com/pkb_Home?id=kA31I000000I8kF&l=fr&c=category_uq%3AUQ_C1_1&fs=Search&pn=1',
      PRIVACY_POLICY_URL:
        'https://faq-ca.uniqlo.com/pkb_Home?id=kA31I000000I8kK&l=fr&fs=Search&pn=1',
      HOME_PAGE_URL: 'https://uniqlo.com/ca/fr/',
      CONTACT_US_URL: 'https://faq-ca.uniqlo.com/pkb_Home?l=fr',
    },
  },
  POSTCODE_FORMAT: /[A-Z][0-9][A-Z] ?[0-9][A-Z][0-9]/g,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },
  SHOW_COUNTRY_LANGUAGE_MODAL: {
    [BRAND_LIST.UQ]: CountryLanguageSwitcher.HEADER_SWITCHER_MODAL,
    [BRAND_LIST.GU]: CountryLanguageSwitcher.HEADER_SWITCHER_DISABLED,
    [BRAND_LIST.PL]: CountryLanguageSwitcher.HEADER_SWITCHER_DISABLED,
  },

  AM_FORMAT: ' AM',
  PM_FORMAT: ' PM',
  LANGUAGE_OPTIONS: {
    [`${Countries.CA}/${Languages.EN}`]: {
      lid: `text_locale_en`,
      label: `#{PLACEHOLDER_COUNTRY}`,
    },
    [`${Countries.CA}/${Languages.FR}`]: {
      lid: `text_locale_fr`,
      label: `#{PLACEHOLDER_COUNTRY}`,
    },
  },
  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
    [BRAND_LIST.GU]: false,
    [BRAND_LIST.PL]: false,
  },
}

export default CanadaLocale
